<template>
  <v-container id="subscriptions">
    <v-row>
      <v-col
        cols="12"
      >
        <v-container>
          <v-row
            v-if="subscription"
          >
            <v-col md="12">
              <base-material-card
                color="info"
                :title="title"
                class="px-5 py-3"
                top-actions
              >
                <v-form>
                  <v-container class="py-0">
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <div>
                          <h6 class="title text-uppercase">
                            Customer
                          </h6>
                          <router-link
                            v-if="customer"
                            :to="{ name: 'CustomerDetails', params: { uid: customer.uid } }"
                            class="ml-3 material"
                          >
                            {{ customer.name }}
                          </router-link>
                        </div>
                        <div>
                          <h6 class="title text-uppercase">
                            Vendor
                          </h6>
                          <span class="ml-3 material">
                            {{ product ? product.vendorDisplayName : '' }}
                          </span>
                        </div>
                        <div>
                          <h6 class="title text-uppercase">
                            Product
                          </h6>
                          <router-link
                            v-if="product"
                            :to="{ name: 'Product', params: { uid: product.uid } }"
                            class="ml-3 material"
                          >
                            {{ product ? product.displayName : '' }}
                          </router-link>
                        </div>
                        <div>
                          <h6 class="title text-uppercase">
                            Original order
                          </h6>
                          <router-link
                            v-if="subscription.originatingOrderId"
                            :to="{ name: 'Order', params: { uid: subscription.originatingOrderId } }"
                            class="ml-3 material"
                          >
                            {{ subscription.createdDate | moment("DD/MM/YYYY") }}
                          </router-link>
                        </div>
                      </v-col>
                      <v-col
                        cols="6"
                        md="3"
                      >
                        <div>
                          <h6 class="title text-uppercase">
                            MSRP Pricing
                          </h6>
                          <pricing-table
                            :price-items="priceInfo.priceItems || []"
                            :active-subscription-count="priceInfo.activeCustomerSubscriptionCount"
                            :is-msrp="true"
                          />
                        </div>
                      </v-col>
                      <v-col
                        cols="6"
                        md="3"
                      >
                        <div>
                          <h6 class="title text-uppercase">
                            Reseller Pricing
                          </h6>
                          <pricing-table
                            :price-items="priceInfo.priceItems || []"
                            :active-subscription-count="priceInfo.activeSubscriptionCount"
                          />
                        </div>
                      </v-col>
                      <v-col
                        v-if="productDetails && productDetails.description"
                        cols="12"
                      >
                        <div>
                          <h6 class="title text-uppercase">
                            Description
                          </h6>
                          <div
                            class="ml-3 material"
                            v-html="productDetails.description"
                          />
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
                <template v-slot:actions>
                  <v-row
                    no-gutters
                    align="center"
                  >
                    <v-col
                      cols="auto"
                      class="mr-auto"
                    >
                      <v-icon class="mr-1">
                        mdi-menu-left
                      </v-icon>
                      <router-link
                        :to="{ name: 'Subscriptions', }"
                      >
                        <span>All Subscriptions</span>
                      </router-link>
                    </v-col>
                    <v-col cols="auto">
                      <v-btn
                        class="px-2 ml-1"
                        color="success"
                        @click="openUpdateDialog()"
                      >
                        Change quantity
                      </v-btn>
                      <v-btn
                        color="error"
                        class="v-btn--tight"
                        @click="showCancel()"
                      >
                        Cancel subscription
                      </v-btn>
                    </v-col>
                  </v-row>
                </template>
              </base-material-card>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <base-material-card
                inline
                icon="mdi-file-chart-outline"
                title="Keys"
                class="px-5 py-3"
              >
                <v-simple-table>
                  <tbody>
                    <tr
                      v-for="(item, index) in subscription.keys"
                      :key="index"
                    >
                      <td>
                        {{ item }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </base-material-card>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <base-material-card
                inline
                icon="mdi-file-chart-outline"
                title="History"
                class="px-5 py-3"
              >
                <v-simple-table class="history">
                  <tbody>
                    <tr class="current">
                      <td>
                        Current
                      </td>
                      <td />
                      <td>
                        {{ priceInfo.activeCustomerSubscriptionCount }}
                      </td>
                    </tr>
                    <tr
                      v-for="(item, index) in subscription.history"
                      :key="index"
                    >
                      <td>
                        {{ item.changeDate | moment("DD/MM/YYYY") }}
                      </td>
                      <td>
                        {{ item.reason }}
                      </td>
                      <td>
                        {{ item.quantity }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </base-material-card>
            </v-col>
          </v-row>
          <v-row
            v-else
          >
            <div>
              <h3 class="text-center">
                No subscription to display
              </h3>
            </div>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <!-- Need the if statement to avoid an error when the subscription has not been loaded yet-->
    <v-dialog
      v-if="subscription"
      v-model="updateDialog"
      max-width="400"
      @click:outside="resetQuantityDialog"
    >
      <v-card>
        <v-card-title>
          Change Quantity
          <v-spacer />
          <v-icon
            aria-label="Close"
            @click="cancelUpdate()"
          >
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <p>Enter a number to set the new quantity or prefix it with + or - to increase/decrease by a specific amount.</p>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="desiredQuantityInput"
                label="Desired Quantity"
                class="purple-input"
                :error-messages="errorMessages.newQuantity"
              />
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-model="subscription.quantity"
                label="Current Quantity"
                class="purple-input"
                disabled
                type="number"
              />
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-model="quantityChangeDisplay"
                cols="4"
                label="Quantity Change"
                class="purple-input"
                disabled
              />
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-model="newQuantity"
                cols="4"
                label="New Quantity"
                class="purple-input"
                disabled
                type="number"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text
          v-if="showCancelConfirm"
          class="warning--text"
        >
          Setting the quantity to zero will cancel your subscription
        </v-card-text>

        <v-card-text class="pb-6 pt-12 text-center">
          <v-btn
            class="mr-3"
            text
            @click="cancelUpdate()"
          >
            Close
          </v-btn>

          <debounce-v-btn
            v-if="!showCancelConfirm && validUpdate"
            color="success"
            text
            @click="saveUpdate()"
          >
            Submit
          </debounce-v-btn>
          <debounce-v-btn
            v-if="showCancelConfirm"
            color="warning"
            text
            @click="cancelSubscription()"
          >
            Cancel
          </debounce-v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <cancel-subscription-dialog
      :visible="cancelDialog"
      :subscription-to-cancel="subscription"
      @close="handleCancelClose"
    />
  </v-container>
</template>

<script>
  import productService from '@/services/productService'
  import PricingTable from '../views/dashboard/components/PricingTable.vue'
  import CancelSubscriptionDialog from '../views/components/custom/dialogs/CancelSubscriptionDialog.vue'

  export default {
    components: {
      PricingTable,
      CancelSubscriptionDialog,
    },
    props: {
      uid: {
        type: String,
        required: false,
        default: null,
      },
    },
    data: () => ({
      loading: true,
      priceInfo: {},
      updateDialog: false,
      desiredQuantityInput: '',
      errorMessages: {
        newQuantity: [],
      },
      cancelDialog: false,
    }),
    computed: {
      title () {
        return this.product
          ? 'Subscription - ' + this.product.displayName + ' - ' + this.variant.name
          : 'Subscription'
      },
      subscription () {
        if (this.$store.state.subscriptions.data.length > 0) {
          return this.$store.state.subscriptions.data.find(subscription => subscription.uid === this.uid)
        }
        return null
      },
      product () {
        return this.$store.state.products.list.find(product =>
          product.variants.some(variant => variant.uid === this.subscription.productVariantId)
        )
      },
      variant () {
        if (!this.product) { return null }
        return this.product.variants.find(v => v.uid === this.subscription.productVariantId)
      },
      customer () {
        return this.$store.state.customers.data.find(customer =>
          customer.uid === this.subscription.customerId
        )
      },
      productDetails () {
        return this.$store.state.products.detailsList.find(detail => detail.nodeId === this.product.contentNodeId)
      },
      quantityChange () {
        var firstChar = this.desiredQuantityInput.charAt(0)
        var number = this.desiredQuantityInput.substring(1)
        if (isNaN(number)) {
          return null
        }
        if (firstChar === '+') {
          return parseInt(number)
        }
        if (firstChar === '-') {
          return parseInt(number) * -1
        }
        if (this.desiredQuantityInput.length > 0 && isNaN(this.desiredQuantityInput) === false && this.subscription) {
          return this.desiredQuantityInput - this.subscription.quantity
        }
        return null
      },
      quantityChangeDisplay () {
        if (this.quantityChange === null || isNaN(this.quantityChange)) {
          return 0
        }
        if (this.quantityChange > 0) {
          return '+' + this.quantityChange
        }
        return this.quantityChange
      },
      newQuantity () {
        if (!this.subscription) {
          return null
        }
        return this.subscription.quantity + this.quantityChange
      },
      showCancelConfirm () {
        return this.newQuantity === 0
      },
      validUpdate () {
        return this.quantityChange != null && this.errorMessages.newQuantity.length === 0
      },
      subscriptionHistory () {
        // need this to watch only the history
        if (!this.subscription) {
          return null
        }
        return this.subscription.history
      },
    },
    watch: {
      newQuantity: function (newValue, oldValue) {
        this.errorMessages.newQuantity = []
        if (newValue === null || !this.variant) {
          return
        }
        if (newValue < 0) {
          this.errorMessages.newQuantity.push('Can not have a negative value')
          return
        }
        if (newValue !== 0 && newValue < this.variant.minimumOrderAmount) {
          this.errorMessages.newQuantity.push('Can not change below the minimum order amount (' + this.variant.minimumOrderAmount + ')')
        }
      },
      subscriptionHistory: async function (newValue, oldValue) {
        if (!this.subscriptionHistory || !this.product || !this.subscription) { return }
        var priceInfoApiResult = await productService.getVariantPrices(this.product.uid, this.subscription.productVariantId, this.subscription.customerId)
        if (priceInfoApiResult.success) {
          this.priceInfo = priceInfoApiResult.value
        }
      },
    },
    created: async function () {
      if (!this.subscription || this.$store.state.subscriptions.data.length === 0) {
        await this.$store.dispatch('RefreshSubscriptions')
      }
      if (this.product && (this.$store.state.products.detailsList.length === 0 || !this.productDetails || !this.productDetails.description)) {
        await this.$store.dispatch('GetProductDetails', this.product.uid)
      }

      if (this.subscription === null) {
        this.loading = false
        return
      }
      var priceInfoApiResult = await productService.getVariantPrices(this.product.uid, this.subscription.productVariantId, this.subscription.customerId)
      if (priceInfoApiResult.success) {
        this.priceInfo = priceInfoApiResult.value
      }
      this.loading = false
    },
    methods: {
      openUpdateDialog () {
        this.updateDialog = true
      },
      cancelUpdate () {
        this.updateDialog = false
        this.resetQuantityDialog()
      },
      gotoCustomer (item) {
        this.$router.push({ name: 'CustomerDetails', params: { uid: item.uid } })
      },
      async saveUpdate () {
        if (await this.$store.dispatch('UpdateSubscriptionQuantity', { subscription: this.subscription, newQuantity: this.newQuantity })) {
          this.updateDialog = false
          this.resetQuantityDialog()
        }
      },
      async cancelSubscription () {
        if (await this.$store.dispatch('cancelSubscription', this.subscription.uid)) {
          this.$router.push({ name: 'Subscriptions' })
        }
      },
      resetQuantityDialog () {
        this.desiredQuantityInput = ''
      },
      showCancel () {
        this.cancelDialog = true
      },
      handleCancelClose (succes) {
        this.cancelDialog = false
        if (succes) { this.$router.go(-1) }
      },
    },
  }
</script>

<style scoped lang="scss">
.history{
  table{
    tr.current{
      td:first-child{
        columns: 2;
      }
      td{
        font-weight: 600;
      }
    }
  }
}
</style>
